import { NameDto } from '../../Common/Types'
import { InstrumentCommissionDto } from './InstrumentComissionDto'
import { IntroducingBrokerLoyaltyDto } from './IntroducingBrokerLoyaltyDto'

export interface IntroducingBrokerDetailsDto {
  allowTestAccounts: boolean
  profile: IBProfile
  instrumentCommissions: InstrumentCommissionDto[]
  id: string
  name: string | null
  status: IntroducingBrokerStatus
  client: Client
  parent: null | { id: string; name: string | null }
  registeredAt: string
  multiLevelRegisteredAt: string | null
  multiTierRegisteredAt: string | null
  isLastMultiTierLevel: boolean
  multiLevelPercentage: number | null
  defaultProgramRegisteredAt: string | null
  commissionCalculationStatus: { id: number; name: string }
  assignee: {
    id: string
    name: string
    status: {
      id: number
      name: string
    }
  } | null
  ibUserGetsClients: boolean
  loyaltyProgramEnabled: boolean
  loyaltyProgramEligible: boolean
  loyaltyDetails?: LoyaltyDetails
  activeClients?: IntroducingBrokerLoyaltyDto['activeClients']
  volumeRatio?: IntroducingBrokerLoyaltyDto['volumeRatio']
  restrictions: NameDto[]
  sibAssignee: {
    id: string
    name: string
    status: {
      id: number
      name: string
    }
  } | null
  sibIsAutoAssigned: boolean
  parentType: NameDto | null
}

export interface LoyaltyDetails {
  bonusNv: number
  loyaltyLots: number
  currentTier: LoyaltyTierDto
  nextTier: LoyaltyTierDto
  nextSubTier: LoyaltyNextSubTierDto
  tiers: LoyaltyTierDto[]
}

interface LoyaltyTierDto {
  id: number
  name: string | null
  htmlPrizeText: string | null
  minLots: number
  minNotionalValue: number
  maxLots: number
  order: number
  subTiers: LoyaltySubTierDto[]
}

interface LoyaltySubTierDto {
  id: number
  name: string | null
  htmlPrizeText: string | null
  lots: number
  recurring: boolean
  recurringInterval: number
}

interface LoyaltyNextSubTierDto {
  id: number
  name: string | null
  htmlPrizeText: string | null
  lots: number
  available: boolean
}

export interface Client {
  id: string
  name: string | null
  introducingBroker: IntroducingBroker
  tickmillCompany: TickmillCompany
  teams: { id: string; team: string | null }[]
  country?: { id: string; name: string | null }
}

interface TickmillCompany {
  id: number
  name: string
}

interface IntroducingBroker {
  name: string | null
  id: string
}

export interface IntroducingBrokerStatus {
  name: string | null
  id: number
}

export interface IBProfile {
  accountGroups: { id: string; name: string | null; currency: { id: string; name: string } }[]
  standardCommissions: []
  id: string
  name: string | null
  description: string | null
  tickmillCompany: { id: number; name: string | null }
}

export enum IntroducingBrokerRestrictions {
  RESTRICT_LOYALTY_CHOICE = 29,
}
export interface AdjustNotionalValue {
  clientId: string
  reasonId: number
  reasonText: string | null
  bonusNvAdjustment: number
}
